// extracted by mini-css-extract-plugin
export default {"mission":"Mission_mission__AqmhH"};